import axios from 'axios';
import apiClient from './api';

export const billingService = {
  async getStatus() {
    const { data } = await apiClient.get('/billing/status/');
    return data;
  },

  async createCheckoutSession({
    plan_tier,
    price_id,
    billing_email,
    full_name,
    company_name,
    aircraft_prefix,
    phone_number,
    checkout_access_token,
    alpha_access_key,
    skip_auth_header = false,
  } = {}) {
    const headers = {};
    if (checkout_access_token) {
      headers['X-Aviatto-Checkout-Token'] = checkout_access_token;
    } else if (alpha_access_key) {
      headers['X-Aviatto-Alpha-Key'] = alpha_access_key;
    }
    const body = {
      plan_tier,
      price_id,
      billing_email,
      full_name,
      company_name,
      aircraft_prefix,
      phone_number,
    };
    const axiosOpts = {
      __skipAuthRefresh: true,
      __skipAuthHeader: Boolean(skip_auth_header),
      headers: Object.keys(headers).length ? headers : undefined,
    };

    try {
      const { data } = await apiClient.post('/billing/create-checkout-session/', body, axiosOpts);
      return data;
    } catch (err) {
      const isTokenRejected =
        err?.response?.status === 403 &&
        String(err?.response?.data?.error || '').includes('restrito');

      if (!isTokenRejected || !checkout_access_token) throw err;

      // Token was created on the local backend — retry there.
      const LOCAL_BACKEND = 'http://127.0.0.1:8000/api';
      const { data } = await axios.post(`${LOCAL_BACKEND}/billing/create-checkout-session/`, body, {
        headers: { 'Content-Type': 'application/json', ...headers },
        timeout: 30000,
      });
      return data;
    }
  },

  async createPortalSession() {
    const { data } = await apiClient.post('/billing/create-portal-session/', {});
    return data;
  },

  async updateCancellation(action = 'cancel') {
    const { data } = await apiClient.post('/billing/cancel-subscription/', { action });
    return data;
  },
};

